'use client'

import dynamic from 'next/dynamic'

const WechatShareConfig = dynamic(() => {
    return import("bwax-ui/page/WechatShareConfig")
}, { 
    ssr: false
})

export default function WechatShareConfigClient() {
    return <WechatShareConfig />
}

